import React from 'react';
import { Box, Stack } from '@mui/material';
import ListingModalSectionLabel from './ListingModalSectionLabel';
import { LISTING_MODAL_SECTION_SX } from './listingModalGlassStyles';

const ListingModalSection = ({ label, badge = null, children, spacing = 1.75 }) => (
  <Box>
    {label ? <ListingModalSectionLabel badge={badge}>{label}</ListingModalSectionLabel> : null}
    <Box sx={LISTING_MODAL_SECTION_SX}>
      <Stack spacing={spacing}>{children}</Stack>
    </Box>
  </Box>
);

export default ListingModalSection;
